import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { Message, Divider, Schema, Form, Button } from 'rsuite';
import { NavLink, useParams, useNavigate } from 'react-router-dom';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}



const DisCode = Schema.Model({
    discode: Schema.Types.StringType().isRequired('این فیلد الزامی است.'),
});


export class Cart extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            item_id: localStorage.getItem('cart') ?? null,
            CartType: localStorage.getItem('CartType') ?? 'course',
            item: null,
            loader_1: null,
            loader_2: null,
            discode_input: null,
            discode: null,
            getway: null,
        };
    }


    // ---------------- componentDidMount--------------------------
    componentDidMount() {

        let data = {
            type: this.state.CartType,
            iid: this.state.item_id,
        };

        Send('page/cart/item', data, true).then((res) => {
            this.setState({ item: res.data.item });

            !res.data.item && this.setState({ item_id: null });


        }).catch((err) => { });

    }




    // ---------------- discode--------------------------

    discode = () => {

        this.setState({ loader_1: true });

        let data = {
            code: this.state.discode_input.discode,
            iid: this.state.item_id,
            type: this.state.CartType,
        }


        Send('page/cart/discount', data, true).then((res) => {
            H1.notfy_success(res.message)
            this.setState({ discode: res.data.discount });
            this.setState({ loader_1: false });
        }).catch((err) => {
            this.setState({ loader_1: false });
        });

    }

    // ---------------- get_pay--------------------------

    get_pay = () => {


        let data = {
            discount: this.state.discode ? this.state.discode.code : false,
            iid: this.state.item_id,
            type: this.state.CartType,
        }

        this.setState({ loader_2: true });

        Send('page/cart/payment/invoice', data, null).then((res) => {


            H1.notfy_loading(res.message)



            
            if(res.data.PayFree === true){

                
                this.props.navigation(res.data.redirect_ok);


            }
            else{

                this.setState({ getway: JSON.parse(res.data.getway) }, () => {

                    document.getElementById("GetwayForm").submit();
                });
                    
            }


 


        }).catch((err) => {
            this.setState({ loader_2: false });
        });





    }



    // ---------------- removeCart--------------------------

    removeCart = () => {
        localStorage.removeItem("cart");
        this.setState({
            item: null,
            item_id: null
        }, () => {
            this.componentDidMount()
        });

    }







    render() {

        H1.page_name("سبد خرید");



        return (


            <div className="h-100 mt-4">


                {this.state.getway &&

                    <div className="d-none">
                        <form id="GetwayForm" action={this.state.getway.action} method={this.state.getway.method}>
                            {Object.keys(this.state.getway.inputs).map(key => (
                                <input type='hidden' name={key} value={this.state.getway.inputs[key]} />
                            ))}
                        </form>
                    </div>

                }



                <div className="c-row">

                    <div className="text-center mb-4 fs-16">
                        سبد خرید
                    </div>



                    {!this.state.item_id &&

                        <Message showIcon type="info">
                            سبد خرید شما خالی میباشد
                        </Message>
                    }

                    {this.state.item &&
                        <>
                            <div className='cours_item bg-white br-16 mb-3'>
                                <div className="cover-box">
                                    <img className='cover' src={this.state.item.cover ?? '/img/not.png'} />
                                </div>
                                <div className="info px-3 py-4">
                                    <div className="fs-16 text-end">
                                        <span className="icon-Close cc-red me-2" onClick={() => this.removeCart()}></span>
                                    </div>

                                    <div className="py-2"> {this.state.item.name} </div>

                                    {this.state.item.archive_count > 0 &&
                                        <div className="fs-10 cc-2">
                                            {this.state.item.archive_count} جلسه   <span className='mx-1'>●</span> {H1.TimeConvert(this.state.item.archive_time, ['h', 'm'])}
                                        </div>
                                    }

                                    <div className="cc-1 mt-3"> {H1.formatNumber(this.state.item.price)} تومان</div>
                                </div>
                            </div>





                            <Form readOnly={this.state.discode ? true : false} model={DisCode} checkTrigger='none' noValidate={true} align="middle" onChange={(val) => this.setState({ discode_input: val })} onCheck={(e) => H1.isEmpty(e) && this.discode()}  >

                                <Form.Group controlId="discode" className='position-relative' >
                                    <Form.Control name="discode" type="text" className={`p-3 in_s1 ${this.state.discode ? 'cc-green' : ''}`} placeholder='کد تخفیف خود را وارد نمایید' />
                                    <Button disabled={this.state.discode ? true : false} className={`check_discode_btn ${this.state.discode ? 'en' : ''}`} appearance="subtle" type="submit" loading={this.state.loader_1}   ><span className="icon-Done ic"></span></Button>
                                </Form.Group>

                            </Form>




                            <div className="pay-box bg-white mt-3 p-3 br-16 d-flex flex-column">


                                <div className="p-row">  جمع کل   <span className='float-end fs-18'> {H1.formatNumber(this.state.item.price)}  <span className='fs-12 ms-1'> تومان  </span> </span>   </div>


                                <div className="p-row mt-2">   تخفیف   <span className='float-end fs-18 cc-red'>  {this.state.discode ? H1.formatNumber((this.state.discode.amount / 100) * this.state.item.price) : '0'}  <span className='fs-12 ms-1'> تومان  </span> </span>   </div>


                                <Divider className='my-3' />

                                <div className="p-row mt-2">   قابل پرداخت   <span className='float-end fs-3 cc-green'>  {this.state.discode ? H1.formatNumber(this.state.item.price - ((this.state.discode.amount / 100 * this.state.item.price))) : H1.formatNumber(this.state.item.price)}  <span className='ms-1'> تومان  </span> </span>   </div>


                            </div>


                            <Button  appearance="primary" color="green" block className='fw-light btn_s1 mt-4 mx-auto' onClick={() => this.get_pay()} loading={this.state.loader_2}> پرداخت</Button>



                            <p className='fs-12 text-center mt-4'>لطفا هنگام ارجاع به درگاه پرداخت از خاموش بودن فیلترشکن خود اطمینان حاصل کنید.</p>



                        </>
                    }



                </div>



            </div>


        )
    }
}

export default withParams(Cart);
